<script>
import _ from 'lodash'
export default {
  props: {
    value: {
      type: Object
    }
  },
  data: vm => ({
    checked: false,
    selected: vm.value || null,
    items: [],
    visible: false
  }),
  created() {
    this.load()
  },
  methods: {
    async load() {
      await this.$ordersService
        .getOrders({
          min: this.$enums.OrderStatus.autocomplete,
          max: this.$enums.OrderStatus.autocomplete
        })
        .then(ordersResponse => {
          if (!ordersResponse.totalOrders) return
          const sortedList = this.sort(ordersResponse.ordersList)
          const groupedList = this.group(sortedList)
          this.addItems(groupedList)
          this.visible = true
        })
    },
    sort(orders) {
      // sort / order by autocompletionDate
      return _.orderBy(orders, item => item.orderSchedule.autocompletionDate, [
        'asc'
      ])
    },
    group(orders) {
      const groupByWeek = orders.reduce((acc, order) => {
        // create a composed key
        const yearWeek = `${this.$t('component.orders.ordersSelectSchedule.week'
        )}: ${this.momentDate(
          order.orderSchedule.autocompletionDate
        ).week()} (${this.momentDate(
          order.orderSchedule.autocompletionDate
        ).year()})`
        // add this key as a property to the result object
        if (!acc[yearWeek]) {
          acc[yearWeek] = []
        }
        // push the current date that belongs to the year-week calculated befor
        acc[yearWeek].push(order)
        return acc
      }, {})
      return groupByWeek
    },
    addItems(elements) {
      Object.keys(elements).forEach(element => {
        // add header
        this.items.push({ header: element })
        // add items
        elements[element].forEach(order => {
          this.items.push({
            text: this.momentDate(
              order.orderSchedule.autocompletionDate
            ).format('<b>dddd</b>,<br> DD.MM.YYYY HH:mm:ss'),
            value: order.orderId,
            icon: 'mdi-calendar-outline',
            order: order
          })
        })
      })
    }
  }
}
</script>
<template>
  <v-card flat elevation="0">
    <v-card-text class="pa-0">
      <v-checkbox
        v-if="visible"
        id="upload-orders-select-scheduled"
        v-model="checked"
        :label="$t('component.orders.ordersSelectSchedule.checkbox.label')"
        @change="value.checked = $event">
      </v-checkbox>
      <v-select
        v-if="visible && checked"
        id="upload-scheduled-order-select"
        v-model="selected"
        :items="items"
        :label="$t('component.orders.ordersSelectSchedule.select.label')"
        :placeholder="$t('component.orders.ordersSelectSchedule.select.placeholder')"
        dense
        outlined
        @change="value.id = $event">
        <template #[`item`]="{ item }">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-icon
                v-if="item.icon"
                v-bind="attrs"
                color="secondary"
                class="pr-1"
                v-on="on">
                {{ item.icon }}
              </v-icon>
              <span
                v-bind="attrs"
                :id="`upload-scheduled-order-select-item-${item.order.orderNumber}`"
                v-on="on"
                v-html="item.text" />
            </template>
            <span :id="`upload-scheduled-order-select-tooltip-${item.order.orderNumber}`">
              {{ $t('component.orders.ordersSelectSchedule.tooltip.order.number') }}
              {{ item.order.orderNumber }}</span>
          </v-tooltip>
        </template>
        <template #[`selection`]="{ item }">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-icon
                v-if="item.icon"
                v-bind="attrs"
                color="secondary"
                class="pr-1"
                v-on="on">
                {{ item.icon }}
              </v-icon>
              <span v-bind="attrs" v-on="on" v-html="item.text" />
            </template>
            <span>
              {{ $t('component.orders.ordersSelectSchedule.tooltip.order.number') }}
              {{ item.order.orderNumber }}</span>
          </v-tooltip>
        </template>
      </v-select>
    </v-card-text>
  </v-card>
</template>